import type { CategoryScoringMap, Company, Exam, Project } from "../api/dto";
import type { QuestionSet } from "../api/dto/QuestionSet";
import { BadgeStyle } from "../components/data/Badge";

export const scoreBadgeStyle: { [color: string]: BadgeStyle } = {
  green: BadgeStyle.success,
  amber: BadgeStyle.warning,
  red: BadgeStyle.danger,
};

/** Picks the scoring map to use: exam, then project, then company, then question set default. */
export function resolveScoringMap(
  exam: Exam,
  project: Project | null | undefined,
  company: Company | null | undefined,
  questionSet: QuestionSet | null | undefined,
): CategoryScoringMap {
  return (
    exam.scoringOverride ??
    project?.scoringOverride ??
    company?.scoringOverride ??
    questionSet?.scoringPerCategory ??
    {}
  );
}

/** Finds the classification a score falls into for a category. */
export function getScoreClassification(
  scoringMap: CategoryScoringMap,
  category: string,
  score: number,
): { color: string; classification: string } | null {
  const scorings = [...(scoringMap[category] ?? [])].sort((a, b) => b.fromScore - a.fromScore);
  return scorings.find((scoring) => score >= scoring.fromScore) ?? null;
}
